import * as React from 'react';
import { LoadingScreen } from '../LoadingScreen';
import { Card } from '../Card';
import { EOffersClickAction } from '../../../../types/tracking';
import * as style from './style.css';
import { ModalWindow } from '@cian/ui-kit';
import { OffersModalContainer } from '../OffersModal';
import { TrackingContext } from '../../../../shared/context';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const LayoutsCards = _ref => {
  let {
    layouts,
    isLoading,
    columnsNumber,
    columnsMaxWidth,
    contactsButton,
    newbuildingId,
    houseId
  } = _ref;
  const {
    trackListingLinkClick,
    trackOffersModalOpen
  } = React.useContext(TrackingContext);
  const [open, setOpen] = React.useState(false);
  const [layoutKey, setLayoutKey] = React.useState();
  const columnsStyle = React.useMemo(() => ({
    gridTemplateColumns: "repeat(".concat(columnsNumber, ", minmax(auto, ").concat(columnsMaxWidth, "px))")
  }), [columnsNumber, columnsMaxWidth]);
  const onCardClick = React.useCallback(key => {
    setLayoutKey(key);
    trackOffersModalOpen();
    setOpen(true);
  }, [trackOffersModalOpen]);
  const onLinkClick = React.useCallback(() => {
    trackListingLinkClick(EOffersClickAction.fromDeveloper);
  }, [trackListingLinkClick]);
  const onClose = React.useCallback(() => setOpen(false), []);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: style['cards-list'],
      style: columnsStyle,
      children: layouts.map(layout => /*#__PURE__*/_jsx(Card, {
        layout: layout,
        onClick: onCardClick,
        onLinkClick: onLinkClick
      }, layout.layoutKey))
    }), /*#__PURE__*/_jsx(ModalWindow, {
      open: open,
      onClose: onClose,
      size: "M",
      fixed: false,
      children: /*#__PURE__*/_jsx(OffersModalContainer, {
        contactsButton: contactsButton,
        layoutKey: layoutKey,
        newbuildingId: newbuildingId,
        houseId: houseId
      })
    })]
  });
};